import { render, staticRenderFns } from "./addCarScetch.vue?vue&type=template&id=e15384b2&"
import script from "./addCarScetch.vue?vue&type=script&lang=js&"
export * from "./addCarScetch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports